import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class SalesPartnerHowDoesItWorkSlider {
  constructor() {
    this.main = document.querySelector('.section--work');
    this.list = document.querySelector(".carousel__nav-list");
    this.listItems = gsap.utils.toArray(".carousel__nav-item", this.list);
    this.slides = gsap.utils.toArray(this.main.querySelectorAll(".carousel__item"));
    this.tl = gsap.timeline();
    this.myST = ScrollTrigger.create({
      animation: this.tl,
      id: "st",
      trigger: this.main,
      start: "top top",
      end: "+="+this.main.clientHeight * (this.slides.length - 1),
      pin: this.main,
      scrub: true,
      snap: {
        snapTo: 1 / (this.slides.length)
      },
      markers: false //change TRUE for debugg
    });
    document.addEventListener('beforeunload', () =>
      setTimeout(() => window.scrollTo(0, 0), 10)
    );
  
    this._setAnimation();
  }

  _setAnimation(){
    gsap.set(this.slides, {  xPercent: ()=>{ return (window.innerWidth<768?125:0)}, yPercent: ()=>{ return (window.innerWidth>768?125:0)},scale:0.5 ,opacity: 0 });
    this.listItems.forEach((item, i) => {
      item.addEventListener("click", e => {
        e.preventDefault();
        const percent = this.tl.labels[e.target.getAttribute("data-target")] / this.tl.totalDuration();
        const scrollPos = this.myST.start + (this.myST.end - this.myST.start) * percent;
        gsap.to(window, {duration: 2, scrollTo: scrollPos});
      });
      
      const previousItem = this.listItems[i - 1];
      if (previousItem) {
        this.tl
          .to(item, { background: "#ed3c3c",boxShadow:'0 0 16px #ed3c3c' }, 0.5 * (i))
          .to(
            this.slides[i],
            {
              opacity: 1,
              yPercent: 0,
              xPercent: 0,
              scale:1,
            },
            '<'
          )
          .to(previousItem, { backgroundColor: '#424b58',	boxShadow:'0 0 16px transparent' }, '<')
          .to(
            this.slides[i - 1],
            {
              opacity: 0,
              yPercent: ()=>{ return (window.innerWidth>768?-125:0)},
              xPercent: ()=>{ return (window.innerWidth<768?-125:0)},
              scale:0.5,
            },
            '<'
          ).add("our-work-"+(++i))
      } else {
        gsap.set(item, { background: "#ed3c3c",boxShadow:'0 0 16px #ed3c3c' });
        gsap.to(this.slides[i], { yPercent:0, xPercent:0, opacity: 1,scale:1, duration:0},0);
        this.tl.add("our-work-"+(++i), "+=0")
      }
    });
  }
}

export default SalesPartnerHowDoesItWorkSlider;
